<template>
  <main role="main" class="content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Administrador' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Administradores',
                href: '#/admin-users',
              },
              {
                text: 'Cadastro de usuários',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="state.email"
                  type="email"
                  required
                  placeholder="Informe o email"
                  :state="isOk('email')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('email')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-2" label="Nome" label-for="input-3">
                <b-form-input
                  id="input-3"
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Senha"
                label-for="input-3"
                v-if="!viewData.id"
              >
                <b-form-input
                  id="input-3"
                  v-model="state.password"
                  required
                  placeholder="Informe a senha"
                  :state="isOk('password')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('password')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-4"
                label="Perfil de permissões"
                label-for="input-group-4"
              >
                <select v-model="state.profile" class="form-control">
                  <option value="">Selecione o perfil</option>
                  <option value="admin">Administrador</option>
                  <option value="financial">Financeiro</option>
                  <option value="sales">Vendas</option>
                  <option value="operations">Operacional</option>
                </select>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'admin-users-edit',
  data: function() {
    return {
      state: {
        email: '',
        password: '',
        profile: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/admin-user/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async save() {
      try {
        await API.post('/execute', {
          path: this.viewData.id
            ? `/admin-user/${this.viewData.id}`
            : '/admin-user/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });
        this.$router.push('/admin-users');
        this.$toast.success('Administrador incluído com sucesso');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {},
};
</script>
